import { getUserAttributes } from '../../';

export async function getUserEmail() {
  const user = await getUserAttributes();
  return user?.email;
}
